import React from 'react';
import { useIntl } from 'react-intl';
import { Box, Breadcrumbs } from '@mui/material';
import { generatePath, Link as RouterLink } from 'react-router-dom';
import { Home as HomeIcon } from '@mui/icons-material';
import { StyledRescuerBreadcrumb, StyledRescuerTextBreadcrumb } from '../../Components/StyledRescuerBreadcrumb';
import routes from '../../../../../routes';

const ClaimRescueBreadcrumb = () => {
  const { formatMessage } = useIntl();

  return (
    <Box boxShadow={0}>
      <Breadcrumbs aria-label="breadcrumb">
        <StyledRescuerBreadcrumb
          component={RouterLink}
          to={generatePath(routes.mobileDashboard)}
          label={formatMessage({ id: 'breadcrumbs.home' })}
          icon={<HomeIcon style={{ color: '#fff' }} fontSize="small" />}
        />
        <StyledRescuerTextBreadcrumb component="a" href="#" label={formatMessage({ id: 'breadcrumbs.claim-rescue' })} />
      </Breadcrumbs>
    </Box>
  );
};

export default ClaimRescueBreadcrumb;
